// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Menu_scroll-black__DbdMg","menu":"Menu_menu__2ItWd","item":"Menu_item__YH5oz","disabled":"Menu_disabled__57jS2"};